import { gql } from '@apollo/client'
import { AddressFragment } from './address.fragments'

export const UserInfoFragment = gql`
    fragment userInfoFragment on User {
        dataType
        id
        email
        firmId
        profileInfo {
            address {
                ...addressFragment
            }
            phone
            firstName
            lastName
            imageUrl
            professionalRole
            professionalDiscipline
            title
            prefix
            suffix
        }
        role
        status
        siteId
    }
    ${AddressFragment}
`
